import React, { useEffect, useState } from 'react';
import './Checkout.scss';
import { Button, StepsIndicator } from '../../components/ui';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import cartSlice, { getCart } from '../../store/slices/cart.slice';
import Customer from '../../store/interfaces/customer.interface';
import Cart from './mini-cart/Cart';
import FormData from './form-data/FormData';
import Shipping from '../../store/interfaces/shipping.interface';

import helper from '../../constants/helper';

const Checkout = () => {
  const dispatch = useDispatch();
  const { customer } = useSelector(getCart);
  const history = useHistory();

  const [shippingInput, setShippingInput] = useState<Shipping>({
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    countryCode: '1',
    stateCode: '0',
    phoneNumber: '',
    faxNumber: '',
    address1: '',
    address2: '',
    city: '',
    zip: '',
  });

  const [billingInput, setBillingInput] = useState<Customer>({
    firstName: '',
    lastName: '',
    email: '',
    paymentType: 'cash',
    countryCode: '1',
    stateCode: '0',
    company: '',
    phoneNumber: '',
    faxNumber: '',
    address1: '',
    address2: '',
    city: '',
    zip: '',
  });

  const [shippingMethodInput, setShippingMethodInput] = useState('standard');
  const [paymentMethodInput, setPaymentMethodInput] = useState('cash');
  const [termsAndConditionInput, setTermsAndConditionInput] = useState(false);
  const [step, setStep] = useState<number>(0);

  useEffect(() => {
    setBillingInput(billingInput);
  }, [billingInput]);

  useEffect(() => {
    setShippingInput(shippingInput);
  }, [shippingInput]);

  useEffect(() => {
    setStep(step);
  }, [step]);

  const changeStep = (num: number, user?: Shipping) => {
    console.log(user);
    switch (num) {
      case 1:
        if (user) {
          dispatch(cartSlice.actions.setCustomer(user));
        }
        break;
      case 2:
        if (user) {
          dispatch(cartSlice.actions.setShipping(user));
        }
        break;
      default:
        break;
    }
    setStep(num);
  };

  const inputOnChange = (event, input?: string) => {
    if (input === 'billing') {
      if (event.target.value == 'true' && event.target.name == 'billing-data') {
        setBillingInput({
          ...billingInput,
          ...customer,
        });
      } else {
        setBillingInput({
          ...billingInput,
          [event.target.id.split('-')[1]]: event.target.value,
        });
      }
    } else if (input === 'shipping') {
      if (event.target.value == 'true' && event.target.name == 'shipping-data') {
        setShippingInput({
          ...shippingInput,
          ...customer,
        });
      } else {
        setShippingInput({
          ...shippingInput,
          [event.target.id.split('-')[1]]: event.target.value,
        });
      }
    } else if (input === 'shippingMethod') {
      setShippingMethodInput(event.target.value);
    } else if (input === 'paymentMethod') {
      setPaymentMethodInput(event.target.value);
    } else if (input === 'termsAndCondition') {
      setTermsAndConditionInput(event.target.checked);
    }
  };

  const saveOrder = () => {
    if (termsAndConditionInput) {
      dispatch(cartSlice.actions.setOrderId(helper.generateOrderId()));
      dispatch(cartSlice.actions.setSessionId(helper.generateSessionId()));
      history.push('/checkout/completed');
    }
  };

  return (
    <div className="template-cart-checkout">
      <StepsIndicator count={3} step={2}></StepsIndicator>
      <div className="wrapper">
        <div className="checkout-info">
          <ul className="checkout-steps">
            <li className={step === 0 ? 'active' : ''}>
              <div className="step-title">
                <h2>1. Billing address</h2>
              </div>
              <div className="checkout checkout-step-billing step-content">
                <div className="checkout-data">
                  <div className="select-billing-address">
                    <label>
                      Select a billing address from your address book or enter a new address.
                    </label>
                  </div>
                  <FormData
                    address="billing"
                    key="billing"
                    data={customer}
                    changeStep={changeStep}
                  />
                </div>
              </div>
            </li>
            <li className={step === 1 ? 'active' : ''}>
              <div className="step-title">
                <h2>2. Shipping Address</h2>
              </div>
              <div className="checkout checkout-step-shipping step-content">
                <div className="checkout-data">
                  <div className="select-billing-address">
                    <label>
                      Select a billing address from your address book or enter a new address.
                    </label>
                  </div>
                  <FormData
                    address="shipping"
                    key="shipping"
                    data={customer}
                    back={() => changeStep(0)}
                    changeStep={changeStep}
                  />
                </div>
              </div>
            </li>
            <li className={step === 2 ? 'active' : ''}>
              <div className="step-title">
                <h2>3. Shipping Method</h2>
              </div>
              <div className="checkout checkout-step-shipping-method step-content">
                <div className="checkout-data">
                  <div
                    className="shipping-method"
                    onChange={e => {
                      inputOnChange(e, 'shippingMethod');
                    }}
                  >
                    <input
                      type="radio"
                      name="shippingMethod"
                      value="standard"
                      className="form-radio"
                      defaultChecked
                    />
                    <span>Standard ($0.00) Standard Delivery Schedule</span>
                    <br />
                    <input
                      type="radio"
                      name="shippingMethod"
                      value="express"
                      className="form-radio"
                    />
                    <span>Express ($0.00)Delivery within 3 days</span>
                  </div>
                  <div className="cta-container">
                    <Button click={() => changeStep(1)}>Back</Button>
                    <Button className="button submit-button" click={() => changeStep(3)}>
                      Continue
                    </Button>
                  </div>
                </div>
              </div>
            </li>
            <li className={step === 3 ? 'active' : ''}>
              <div className="step-title">
                <h2>4. Payment Method</h2>
              </div>
              <div className="checkout checkout-step-payment-method step-content">
                <div className="checkout-data">
                  <div className="co-payment-method">
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="cash"
                      className="form-radio"
                      defaultChecked
                      onChange={e => {
                        inputOnChange(e, 'paymentMethod');
                      }}
                    />
                    <span>Check / Money Order</span>
                  </div>
                  <div className="cta-container">
                    <Button click={() => changeStep(2)}>Back</Button>
                    <Button className="button submit-button" click={() => changeStep(4)}>
                      Continue
                    </Button>
                  </div>
                </div>
              </div>
            </li>
            <li className={step === 4 ? 'active' : ''}>
              <div className="step-title">
                <h2>5. Payment information</h2>
              </div>
              <div className="checkout checkout-step-payment-information step-content">
                <div className="checkout-data">
                  <div className="payment-info">
                    <p>Please make your payment to accredited payment center</p>
                  </div>
                  <div className="cta-container">
                    <Button click={() => changeStep(3)}>Back</Button>
                    <Button className="button submit-button" click={() => changeStep(5)}>
                      Continue
                    </Button>
                  </div>
                </div>
              </div>
            </li>
            <li className={step === 5 ? 'active' : ''}>
              <div className="step-title">
                <h2>6. Confirm Order</h2>
              </div>
              <div className="checkout checkout-step-confirm-order step-content">
                <div className="checkout-data">
                  <div className="terms-and-condition">
                    <input
                      type="checkbox"
                      name="termsAndCondition"
                      defaultChecked={termsAndConditionInput}
                      onChange={e => {
                        inputOnChange(e, 'termsAndCondition');
                      }}
                    />
                    <span>
                      I agree <a href="#">terms and conditions</a>
                    </span>
                  </div>
                  <div className="cta-container">
                    <Button click={() => changeStep(4)}>Back</Button>
                    <Button className="button submit-button" click={saveOrder}>
                      Confirm
                    </Button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="order-info">
          <h2>YOUR ORDER</h2>
          <Cart />
          <div className="cart"></div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
